module.exports = __webpack_public_path__ + "static/images/icon-linkedin.1d475d9b52d35b26f95de4e99ccb95f0.svg";